@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="notifications-content-page" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    <header>
        <div class="title">
            <lucide-angular name="bell" size="44"></lucide-angular>
            <h1>{{ 'nav.notifications.title' | translate }}</h1>
        </div>
    </header>

    <div id="content">
        @if((jobs$ | async)?.length === 0){
        <p class="empty-list">{{ 'notifs.empty_list' | translate }}</p>
        }
        @else {
        @for(job of (jobs$ | async); track $index){
        <app-job-row [job]="job" (onClick)="navToAction(job)"></app-job-row>
        }
        }
    </div>
</div>